import { Block, Typography, theme } from '@aloft/toolkit-sui';

import {
  SimilarityChipType,
  getSimilarityChipType,
} from '../utils/getSimilarityChipType.ts';

const CHIP_STYLES: Record<
  SimilarityChipType,
  { backgroundColor: string; color: string; label: string }
> = {
  best: {
    backgroundColor: theme.colors.alertSuccessLight,
    color: theme.colors.textSuccess,
    label: 'Best',
  },
  okay: {
    backgroundColor: theme.colors.alertWarningLight,
    color: theme.colors.textWarning,
    label: 'Okay',
  },
  weak: {
    backgroundColor: theme.colors.alertErrorLight,
    color: theme.colors.textError,
    label: 'Weak',
  },
};

export const SimilarityScoreChip = ({ score }: { score: number }) => {
  const chipType = getSimilarityChipType(score);
  const { backgroundColor, color, label } = CHIP_STYLES[chipType];

  return (
    <Block
      __dangerDoNotUseSx={{
        backgroundColor,
        borderRadius: '999px',
        padding: '2px 8px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        variant="body2"
        __dangerDoNotUseSx={{ color, fontWeight: 500, lineHeight: '16px', whiteSpace: 'nowrap' }}
      >
        {label}
      </Typography>
    </Block>
  );
};
